import React, { useMemo } from 'react';
import { fmt } from './formatters';

function MatchDistribution({ totals }) {
  const complete = Number(totals?.complete) || 0;
  const partial = Number(totals?.partial) || 0;
  const noMatch = Number(totals?.no_match) || 0;
  const other = Number(totals?.mapped_incomplete) || 0;
  const total = complete + partial + noMatch + other;

  const segments = useMemo(() => {
    if (total <= 0) {
      return [
        { key: 'empty', pct: 100, className: 'ahri-dash-match-bar__seg--other' },
      ];
    }
    return [
      { key: 'complete', pct: (complete / total) * 100, className: 'ahri-dash-match-bar__seg--complete', label: 'Complete', count: complete },
      { key: 'partial', pct: (partial / total) * 100, className: 'ahri-dash-match-bar__seg--partial', label: 'Partial', count: partial },
      { key: 'none', pct: (noMatch / total) * 100, className: 'ahri-dash-match-bar__seg--none', label: 'No match', count: noMatch },
      { key: 'other', pct: (other / total) * 100, className: 'ahri-dash-match-bar__seg--other', label: 'Mapped incomplete', count: other },
    ].filter((s) => s.pct > 0);
  }, [complete, partial, noMatch, other, total]);

  return (
    <div className="mb-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
        <span className="fw-semibold text-dark">Match distribution</span>
        <span className="text-muted small">{fmt(total)} systems total</span>
      </div>
      <div className="ahri-dash-match-bar mb-3" role="img" aria-label="AHRI match distribution">
        {segments.map((seg) => (
          <div
            key={seg.key}
            className={`ahri-dash-match-bar__seg ${seg.className}`}
            style={{ width: `${seg.pct}%` }}
            title={seg.label ? `${seg.label}: ${seg.count}` : 'No data'}
          />
        ))}
      </div>
      <div className="ahri-dash-legend">
        {total > 0 ? (
          <>
            <span className="ahri-dash-legend__item">
              <span className="ahri-dash-legend__dot" style={{ background: '#6b9080' }} />
              Complete {fmt(complete)}
            </span>
            <span className="ahri-dash-legend__item">
              <span className="ahri-dash-legend__dot" style={{ background: '#a89b6e' }} />
              Partial {fmt(partial)}
            </span>
            <span className="ahri-dash-legend__item">
              <span className="ahri-dash-legend__dot" style={{ background: '#b08a8a' }} />
              No match {fmt(noMatch)}
            </span>
            {other > 0 ? (
              <span className="ahri-dash-legend__item">
                <span className="ahri-dash-legend__dot" style={{ background: '#9ca3af' }} />
                Incomplete {fmt(other)}
              </span>
            ) : null}
          </>
        ) : (
          <span className="text-muted small">No AHRI records to chart yet.</span>
        )}
      </div>
    </div>
  );
}

export default MatchDistribution;
